import { render, staticRenderFns } from "./Keyboard65Fluffy.vue?vue&type=template&id=13e52664&scoped=true&"
import script from "./Keyboard65Fluffy.vue?vue&type=script&lang=js&"
export * from "./Keyboard65Fluffy.vue?vue&type=script&lang=js&"
import style0 from "./Keyboard65Fluffy.vue?vue&type=style&index=0&id=13e52664&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e52664",
  null
  
)

export default component.exports